import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Diagram from "./pages/Diagram";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <App />,
  },
  // {
  //   path: "/diagram",
  //   element: <Diagram />,
  //   errorElement: <Diagram />,
  // },
  {
    path: "/:sessionId",
    element: <App />,
    errorElement: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
